( function( $ ) {
	$( document ).ready( function() {

		var

			Sage = {
				'common': {
					init: function() {
						utilsJS.init();
						initJS.init();
					},
					finalize: function() {
						initJS.finalize();
					}
				},
				'home': {
					init: function() {
						homeJS.init();
					},
					finalize: function() {
						homeJS.finalize();
					}
				},
				'page_template_template_regulations': {
					init: function() {
						regulationsJS.init();
					}
				},
				'page_template_template_airlines': {
					init: function() {
						airlinesJS.init();
					}
				}
			},

			UTIL = {
				fire: function( func, funcname, args ) {
					var fire,
						namespace = Sage;

					funcname = ( funcname === undefined ) ? 'init' : funcname;
					fire = func !== '';
					fire = fire && namespace[func];
					fire = fire && 'function' === typeof namespace[func][funcname];

					if ( fire ) {
						namespace[func][funcname]( args );
					}
				},
				loadEvents: function() {
					UTIL.fire( 'common' );
					$.each( document.body.className.replace( /-/g, '_' ).split( /\s+/ ), function( i, classnm ) {
						UTIL.fire( classnm );
						UTIL.fire( classnm, 'finalize' );
					});
					UTIL.fire( 'common', 'finalize' );
				}
			};

		$( document ).ready( UTIL.loadEvents );
	});
}( jQuery ) );
